<template>
  <a class="pointer add" @click="click" v-c-tooltip.hover.click="lLabel">
    <CIcon name="cil-plus" /> {{ label }}
  </a>
</template>
<script>
export default {
  data() {
    return {
      lLabel: "Add",
    };
  },
  props: ["label"],
  methods: {
    click() {
      this.$emit("click");
    },
  },
  created() {
    if (this.label != "") {
      this.lLabel = this.label;
    }
  },
};
</script>